import md5 from "blueimp-md5"
let SERVER = "./"
if(process.env.NODE_ENV==='development')
{
SERVER = "https://enews.g-bro.net/eSoT/" ;//"http://localhost:8888/"
}

 
import _ from "lodash"
import {
    monthNames
} from "./Reducer";

const SUCCESS = "SUCCESS";


const TOKEN = "93b1a6222217a63a928fe95a1c7f6b2d";
const STAGE="STAGE";
const LIVE="LIVE";
const sSOT="sSoT";
const eSOT="eSoT";


let BUILD=process.env.BUILT_FOR;
console.log("build for "+BUILD+" and "+process.env.NODE_ENV);
const USER_KEY = "USER_KEY"+BUILD;
const USER_BROWSER_TOKEN="USER_BROWSER_TOKEN"+BUILD;
//
const ENV=STAGE;

export {
    STAGE,LIVE,sSOT,eSOT,ENV,BUILD
}



export {
    TOKEN
}
function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  
  
  /*
  returns unique GUID
  */
 function  guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }


export default class Api {



    static  async vote(option_id)
    {
       const {RESULT}=await Api.request("REGISTER_VOTE",{option_id});
       return RESULT;
    }


    static async recordAnalytics(document_id,event,meta_1,meta_2)
    {
        meta_1=meta_1||"";
        meta_2=meta_2||"";
        let uuid=localStorage.getItem(USER_BROWSER_TOKEN);
        await Api.request("RECORD_ANALYTICS",{
            uuid,
            meta_1,
            meta_2,
            document_id,
            event
        })
        

    }


    static uuid()
    {
        let uuid=localStorage.getItem(USER_BROWSER_TOKEN);
        if(uuid!=null)
        {
            return uuid;
        }
        uuid=guid();
        localStorage.setItem(USER_BROWSER_TOKEN,uuid);
        return uuid;
    }


    static async removeVideo(document_id)
    {
        return await Api.adminRequest("REMOVE_VIDEO",{document_id});
    }

    static async getAllPublishedDocuments() {
        return await Api.request("GET_ALL_PUBLISHED_DOCS", {});
    }


    static getParts(month) {

        if (month != null) {
            if (month.indexOf("_") != -1) {
                month = month.toLowerCase();
                const [mm, yy] = month.split("_");
                const index = monthNames.indexOf(mm);
                if (index != -1) {
                    month = index + 1;
                    return [month, yy];
                } else {
                    return [null, null]
                }
            } else {
                return [null, null]
            }
        } else {
            return [null, null]
        }
    }


    /**
     * 
     * @param {string} month 
     */
    static async getDataForMonth(param) {
        const [month, yy] = this.getParts(param)
        return await Api.request("GET_CONTENT", {
            yy,
            month,
            uuid:Api.uuid()
        });

    }

    static async submitForReview(document_id) {
        return await Api.adminRequest("SUBMIT_DOCUMENT", {
            document_id
        });
    }


    static async approveDocument(document_id) {
        return await Api.adminRequest("APPROVE_DOCUMENT", {
            document_id
        });
    }






    static async doDeleteDocument(document_id) {
        return await Api.adminRequest("DELETE_DOCUMENT", {
            document_id
        });
    }

    static async getArticleByIds(id1, id2, id3) {
        let arr = _.compact([id1, id2, id3]);
        if (arr.length > 0) {
            const {
                RESULT,
                ARTICLES
            } = await Api.request("GET_ARTICLES_BY_IDS", {

                ids: arr
            });
            //     debugger;
            if (RESULT == SUCCESS) {
                const toReturn = {};
                _.each(ARTICLES, s => {
                    toReturn[s.id] = s;
                })
                return toReturn;
            }
        }
        return {};
    }

    static async setArticleIndex(article_id, article_index, document_id) {
        return await Api.adminRequest("SET_ARTICLE_INDEX", {
            article_id,
            article_index,
            document_id
        })
    }

    static async deleteArticle(id) {
        return await Api.adminRequest("DELETE_ARTICLE", {
            id
        });

    }

    static async getAllArticles() {
        const {
            RESULT,
            ARTICLES
        } = await Api.adminRequest("GET_ALL_ARTICLES");
        if (RESULT == SUCCESS) {
            return ARTICLES;
        }
    }

    static async saveArticle(title = '', intro = '', byLine = '', body = '', image = '', id) {
        await Api.adminRequest("SAVE_ARTICLE", {
            title,
            intro,
            byLine,
            body,
            image,
            id
        });
    }

    static async saveVideoData(video_type,video, title, desc, document_id) {
        await Api.adminRequest("SAVE_VIDEO", {
            video_type,
            video,
            title,
            desc,
            document_id
        });
    }


    static async getPreviosPollAndOptions(document_id) {
        if (!document_id) {
            return {
                POLL: {},
                OPTIONS: []
            };
        }
        const {
            RESULT,
            OPTIONS,
            POLL
        } = await Api.request("GET_RESULT_POLL", {
            document_id
        });
        if (RESULT == SUCCESS) {

            return {
                OPTIONS,
                POLL
            }
        }


    }


    static async getSelectedPollAndOptions(document_id) {

        if (!document_id) {
            return {
                POLL: {},
                OPTIONS: []
            };
        }

        const {
            RESULT,
            POLL
        } = await Api.request("GET_ACTIVE_POLL", {
            document_id
        });
        if (RESULT == SUCCESS) {
            const {
                RESULT,
                options
            } = await Api.getPollOptions(POLL.id);
            return {
                POLL,
                OPTIONS: options
            }
        }

    }


    static async setActivePoll(poll_id, document_id) {


        return await Api.adminRequest("SET_ACTIVE_POLL", {
            poll_id,
            document_id
        });
    }

    static async setResultPoll(poll_id, document_id) {


        return await Api.adminRequest("SET_RESULT_POLL", {
            poll_id,
            document_id
        });
    }




    static async deletePoll(poll_id) {
        return await Api.adminRequest("DELETE_POLL", {
            poll_id
        });
    }

    static async getPollOptions(poll_id) {
        return await Api.request("GET_POLL_OPTIONS", {
            poll_id
        });
    }

    static async getAllPolls() {
        return await Api.adminRequest("GET_ALL_POLLS", {});
    }


    static async savePoll(poll_title, options, ref_id) {
        return await Api.adminRequest("SAVE_POLL_SETTINGS", {
            poll_title,
            options,
            ref_id
        });
    }

    static async changeBackgroundImage(image, document_id) {
        return await Api.adminRequest("CHANGE_BACKGROUND", {
            image,
            document_id
        });
    }


    static async deleteFile(name, type) {
        return await Api.adminRequest("DELETE_FILE", {
            name,
            type
        });
    }

    static async uploadFile(file, type) {
        const data = new FormData()
        data.append('file', file, file.name)
        data.append('type', type);
        data.append("MeNADMINSERVICES", "UPLOAD_FILE");
        return await Api.adminRequest("UPLOAD_FILE", data, true);

    }



    static async getAllImages(type) {
        const result = await Api.adminRequest("GET_IMAGES", {
            type
        });
        if (result.RESULT == SUCCESS) {
            return result.FILES;
        }
        throw new Error("Error");
    }

    static async saveHeaders(title, sub, document_id) {
        const result = await Api.adminRequest("SAVE_HEADERS", {
            title,
            sub,
            document_id
        });
        if (result.RESULT == SUCCESS) {
            return result.data;
        }
        throw new Error("Error");
    }

    static async doOpenAction(year, month) {

        const result = await Api.adminRequest("OPEN_DOCUMENT", {
            year,
            month
        });
        if (result.RESULT == "SUCCESS") {

            return result.DATA;
        }
        throw new Error("ACCESS error!!");
    }





    static isUserLoggedIn() {
        const str = localStorage.getItem(USER_KEY);
        const obj = JSON.parse(str);
        if (obj) {

            Api.info = obj;

            return true;
        }
        return false;
    }

    static doLogout() {
        localStorage.removeItem(USER_KEY);
        location.reload();
    }

    static async login(UNAME, PWORD) {
        PWORD = md5("d2fdSfk3jf" + PWORD + "LLfeo29f81ii");
        const VALIDATOR = md5("9234jkKsl34" + UNAME + PWORD + "ff20gnwmwsJf");
        let resp = await Api.request("UserLogin", {
            UNAME,
            PWORD,
            VALIDATOR
        });
        if (resp.RESULT == SUCCESS) {
            console.log("login");
            Api.info = resp;
         await  localStorage.setItem(USER_KEY, JSON.stringify(Api.info));
            return true;
        }
        throw new Error("Invalid username or password")
    }




    static async adminRequest(ACTION, body, formField = false) {



        if (!Api.isUserLoggedIn()) {
            //   location.reload();
        }
        if (formField == false) {
            body = body || {};
            body["uid"] = Api.info.USERID;
            body["atoken"] = Api.info.ACCESSTOKEN;
        } else {
            body.append("uid", Api.info.USERID);
            body.append("atoken", Api.info.ACCESSTOKEN);
        }

        return Api.request(ACTION, body, formField);
    }

    static async request(ACTION, body, formField = false) {
        if (formField == false) {
            body = body || {};
            body.MeNADMINSERVICES = ACTION;
            body.uuid=Api.uuid();
        }
        const resp = await fetch(SERVER + "adminarea/menbootstrap.php", {
            method: "POST",
            credentials: "include",
            body: formField == false ? JSON.stringify(body) : body
        });
        try {
            if (resp.headers.get("content-length") == "0") {
                throw new Error("Your session has timed out please login again.");
            }

            let val = await resp.json();

            return val;
        } catch (e) {

            throw e;
        }

    }

}

export {
    SERVER
}